const API_URL = `${process.env.REACT_APP_API_URL}/v1/admin`;

exports.SIGNIN_URL = `${API_URL}/core-sign-in`;
exports.UAC_URL = `${API_URL}/uac`;
exports.GET_COLLECTION_DATA = `${API_URL}/collection-data`;
exports.GET_COL_AGGREGATE_DATA = `${API_URL}/col-aggregate-data`;
exports.GET_COLLECTION_AGGREGATE_DATA = `${API_URL}/collection-aggregate-data`;
exports.USER_URL = `${API_URL}/user`;
exports.AGENT_URL = `${API_URL}/agent-role`;
exports.COUNTRIES_URL = `${API_URL}/get-countries`;
exports.COLLECTORS_URL = `${API_URL}/get-collectors`;
exports.COUNTRYS_URL =  `${API_URL}/get-countries`;
exports.SEARCH_COLLECTION_URL = `${API_URL}/search-collection`;
exports.GET_WASTE_REPORT_URL = (type) => `${API_URL}/waste-report/${type}`;
exports.GET_FUMIGATION_REPORT_URL = `${API_URL}/fumigation-report`;
exports.GET_FINANCE_REPORT_URL = `${API_URL}/finance-report`;
exports.GET_LIVE_ACCOUNT_URL = `${API_URL}/live-account`;
exports.GET_TRANSACTION_REPORT_URL = `${API_URL}/transaction-report`;
exports.ZONE_USER_COUNT_URL = (type, id) => `${API_URL}/zone-user-count/${type}/${id}`;
exports.SEND_SCHEDULE_MESSAGE_URL = `${API_URL}/send-schedule-message`;
exports.GET_TERRITORIES = `${API_URL}/territories`;
exports.PICKUP_URL = `${API_URL}/waste-pickup`;
exports.FUMIGATION_URL = `${API_URL}/fumigation`;
exports.PRODUCT_URL = `${API_URL}/product`;
exports.COMMISSION_URL = `${API_URL}/commission`;
exports.PAYOUT_URL = `${API_URL}/payout`;
exports.QRCODE_URL = `${API_URL}/qrcode`;
exports.MEDIA_URL = `${API_URL}/media`;
exports.GET_PRE_SIGNED_URL = `${API_URL}/generate-pre-signed-url`;
exports.GET_COLLECTION_WASTE_REPORT_URL = `${API_URL}/collection-wastes-report`;
exports.GET_USER_REPORT_URL = `${API_URL}/user-report`;
exports.SUBURB_URL = `${API_URL}/suburb`;
exports.STATE_URL = `${API_URL}/state`;
exports.COUNTRY_URL = `${API_URL}/country`;
exports.COLLECTOR_URL = `${API_URL}/collector`;
exports.GET_ZONE_URL = `${API_URL}/zone`;
exports.TERRITORY_URL = `${API_URL}/territory`;
exports.PRIVILEGE_URL = `${API_URL}/privilege`;
exports.POLICY_URL = `${API_URL}/policy`;
exports.ORGANISATION_URL = `${API_URL}/organisation`;
exports.ZONE_URL = `${API_URL}/zone`;
exports.SCHEDULE_URL = `${API_URL}/schedule`;
exports.NOTIFICATION_URL = `${API_URL}/notification`;
exports.GET_RATE_REPORT_URL = `${API_URL}/rate-report`;
exports.GET_REVENUE_REPORT_URL = `${API_URL}/revenue-report`;
exports.WASTE_URL = `${API_URL}/waste/subscription`;
exports.CITY_URL = `${API_URL}/city`;
exports.FETCH_URL = `${API_URL}/image/`;
exports.GET_COLLECTOR_URL = (id) => `${API_URL}/collector/${id}`;
exports.GET_SALE_REVENUE_REPORT_URL = `${API_URL}/sale-revenue-report`;
exports.GET_RECUR_REVENUE_REPORT_URL = `${API_URL}/recur-revenue-report`;
exports.GET_CUSTOMER_GROWTH_REPORT_URL = `${API_URL}/customer-growth-report`;
exports.GET_USER_URL = (id) => `${API_URL}/user/${id}`;
exports.TRANSACTION_URL = `${API_URL}/transaction`;
exports.SOCKET_URL = 'http://127.0.0.1:3002';
